<script>
    import vulnerabilityService from "../service.js";
    import { format } from "svelte-i18n";
    import { tick } from "svelte";

    let { vulnerability = {}, navigation = false } = $props();

    let tooltipID = $state();

    let published_at = vulnerability.published_at
        ? vulnerability.published_at.split("T")
        : "";

    const handleCopy = async (str, tooltip) => {
        copyText(str, tooltip);
    };

    const copyText = async (str, tooltip) => {
        await tick();
        if ("clipboard" in navigator) {
            navigator.clipboard
                .writeText(str)
                .then(() => {
                    showTooltip(tooltip);
                    hideTooltip(tooltip);
                })
                .catch((err) => console.error(err.name, err.message));
        } else {
            let selBox = document.createElement("textarea");
            selBox.style.position = "fixed";
            selBox.style.left = "0";
            selBox.style.top = "0";
            selBox.style.opacity = "0";
            selBox.value = str;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            // @TODO: upgrade to clipboard API
            try {
                const success = document.execCommand("copy");
            } catch (err) {
                return false;
            }
            showTooltip(tooltip);
            document.body.removeChild(selBox);
            hideTooltip(tooltip);
        }
    };

    const hideTooltip = (tooltip) => {
        setTimeout(() => {
            tooltip.classList.add("trigger-opacity-cero");
            tooltip.classList.remove("trigger-opacity-one");
            setTimeout(() => tooltip.classList.add("d-none"), 1000);
        }, 2000);
    };

    const showTooltip = (tooltip) => {
        tooltip.classList.remove("d-none");
        setTimeout(() => {
            tooltip.classList.remove("trigger-opacity-cero");
            tooltip.classList.add("trigger-opacity-one");
        }, 1000);
    };
</script>

<div class="d-flex flex-container-2item">
    <div>
        <div><strong>ID </strong></div>
        <div class="d-flex">
            {#if navigation}
                <div class="t-vul-id" style="flex: unset !important;">
                    <a href={`/vulnerability/${vulnerability.id}`}
                        >{vulnerability.id}</a
                    >
                </div>
            {:else}
                <div class="t-vul-id" style="flex: unset !important;">{vulnerability.id}</div>
            {/if}
            <button
                class="btn btn-copy far fa-copy"
                title="Copiar al portapapeles"
                aria-label="Copiar"
                style="position: relative; top: -2px; left: 5px; flex: unset !important;"
                onclick={() => handleCopy(vulnerability.id, tooltipID)}
            ></button>
            <span
                id="tooltip-compose"
                class="d-none trigger-opacity-cero copy-tooltip"
                bind:this={tooltipID}>{$format("copied")}</span
            >
        </div>
    </div>
    {#if vulnerability.published_at}
        <div>
            <div><strong>{$format("published")}</strong></div>
            <div class="t-vul-published_at">
                {#if published_at[0]}
                    {published_at[0]}
                {:else}
                    {published_at}
                {/if}
            </div>
        </div>
    {/if}
</div>

<div class="d-flex flex-container-2item">
    <div class="mt-3">
        <div>
            <span
                ><strong>{$format("vulnerability.severity.title")}</strong
                ></span
            >
        </div>
        <div
            class="cvss-badge cvss-{vulnerability.level}"
            style="--mwidth: 70px;"
        >
            <span class="t-vul-priority"
                >{vulnerability.priority < 10 &&
                vulnerabilityService.getDecimalPart(vulnerability.priority) != 0
                    ? vulnerability.priority.toPrecision(2)
                    : vulnerability.priority.toFixed(0)}</span
            >
        </div>
    </div>
    {#if vulnerability.cvss2_vector || vulnerability.cvss3_vector}
        <div class="mt-3">
            <div><strong>CVSS</strong></div>
            {#if vulnerability.cvss}
                <div class="t-vul-cvss3">{vulnerability.cvss}</div>
            {/if}
            {#if vulnerability.cvss2 && !vulnerability.cvss}
                <div class="t-vul-cvss2">{vulnerability.cvss2}</div>
            {/if}
        </div>
    {/if}
</div>
{#if vulnerability.cvss2_vector || vulnerability.cvss3_vector}
    {#if vulnerability.epss}
        <div class="d-flex flex-container-2item">
            <div>
                <div class="mt-3"><strong>EPSS</strong></div>
                <div class="t-vul-epss">
                    {vulnerability.epss && vulnerability.epss < 0.01
                        ? "< 1%"
                        : `${Math.round((parseFloat(vulnerability.epss) * 100).toFixed(2))}%`}
                </div>
            </div>
        </div>
    {/if}
{/if}

<style>
    .d-flex > * {
        flex: 1;
    }
    .flex-container-2item div:first-child {
        flex: 2;
    }
    .cvss-title {
        border-top: 1px solid rgba(0, 0, 0, 0.125);
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        margin-left: -20px;
        margin-right: -20px;
        padding: 0.75rem 1.25rem;
    }
    .cvss-title span {
        font-size: 1.1rem;
    }

    /*.impact-graphic-container {
    border: 1px solid rgba(0, 0, 0, 0.125);
    padding: 10px 25px;
}*/

    .cveData-item {
        display: inline-block;
        margin: 3px;
        padding: 2px 5px;
        border: 0;
        cursor: pointer;
        font-size: 90%;
        border-radius: 5px;
        background: #f8f9fa;
        border: 1px solid #999999;
        border-radius: 5px;
        margin-left: 0;
        cursor: auto;
    }

    .cveData-item.active {
        background: #666;
        border: 1px solid #666;
        color: #ffffff;
    }
</style>
